export default __webpack_public_path__ + "images/value_tags/reef_safe-e6fca878c840849b9efba7ea6543540a.svg";